import { salt } from '../../@helpers';
import React, { Component, Fragment } from 'react';
import IconBlock from './iconBlock';
import './style.scss';

class IconBlocks extends Component {
  render(){
    const { data } = this.props
    const icons = data.lxl_icon_blocks
    // console.log(`iconblocks`, data)
    return (
      <Fragment>
        <section className="icon_block-section">
          <div className="icon_block-container">
            {icons && icons.map(iconBlock => <IconBlock key={salt()} icon={iconBlock} />)}
          </div>
        </section>
      </Fragment>
    )
  }
}

export default IconBlocks